export default __webpack_public_path__ + "static/media/Mobile Development_icon.12979b2b.svg";